module.exports = __webpack_public_path__ + "2f978071c50fce5b6839f30b28377861.glb";